module.exports = __webpack_public_path__ + "img/kuaishou.eb53bdb1.png";